module.exports = __webpack_public_path__ + "img/funding-new12.a2216e2f.png";